import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '@ridango/core';
import { Router } from '@angular/router';
import { CompanyFacade, NotificationFacade } from '@ridango/components';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './account-company-users-add-page.component.html'
})
export class AccountCompanyUsersAddPageComponent implements OnInit {
    powerUserForm: FormGroup;

    constructor(
        private authService: AuthService,
        private notification: NotificationFacade,
        private router: Router,
        private translate: TranslateService,
        private companyFacade: CompanyFacade
    ) {}

    ngOnInit() {
        this.powerUserForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email])
        });
    }

    addUser() {
        const companyId = this.authService.getLoggedInUserCompanyId();

        if (this.powerUserForm.valid && companyId && !isNaN(parseInt(companyId, 10))) {
            const powerUser = this.powerUserForm.value;

            this.companyFacade.addPowerUser(powerUser, companyId);
        } else if (!companyId) {
            this.authService.signOut();
            this.router.navigate([this.translate.currentLang]);
            this.notification.error(this.translate.instant('NO_COMPANY'));
        }
    }
}
